import EventEmitter from 'eventemitter3';
export class MessageSignerWrapper extends EventEmitter {
    worker;
    sign(messageId, content, privateKey) {
        this.worker?.postMessage({
            type: 'sign',
            data: {
                messageId,
                content,
                privateKey,
            },
        }, [content.buffer]);
    }
    startWorker() {
        return new Promise((resolve, _reject) => {
            this.worker = new Worker(new URL('./workers/messagesigner.worker.ts', import.meta.url));
            this.worker.onmessage = (e) => {
                const { type, data } = e.data;
                switch (type) {
                    case 'signedData':
                        this.emit('signedData', data.signature, data.messageId, data.content);
                        break;
                    case 'initCompleted':
                        resolve();
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
            });
        });
    }
    async init() {
        try {
            console.log('Starting MessageSignerWorker');
            await this.startWorker();
        }
        catch (e) {
            console.log('MessageSignerWorker::start error', e);
        }
    }
}
